import Grid from '@mui/material/Grid';
import Modal from '@mui/material/Modal';
import Lottie from 'lottie-react';

import { RecipeMealPlanLoad, RecipeMealPlanSuccess } from '../../utils/lottieRefs';
import styles from './referralLoader.module.css';

const ReferralLoader = ({
    loading,
    hasCompletedLoop,
}: {
    loading: boolean;
    hasCompletedLoop: boolean;
}) => {
    const isLoading = loading || !hasCompletedLoop;

    return (
        <Modal open>
            <Grid className={styles.loader_container}>
                {isLoading?
                    <Lottie animationData={RecipeMealPlanLoad} loop />
                    :
                    <Lottie animationData={RecipeMealPlanSuccess} loop={false} />
                }
            </Grid>
        </Modal>
    );
};

export default ReferralLoader;
